import axiosInstance from "../configs/axios.config";

const SERVER = import.meta.env.VITE_API_URL;

const fetchSuggestions = async (input, filter) => {
  try {
    const response = await axiosInstance.get(
      `${SERVER}/management/getplacesuggestions`,
      {
        params: { input, filter },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching suggestions:", error);
    return [];
  }
};

export { fetchSuggestions };
